export default __webpack_public_path__ + "static/woningbouw-desktop-4131ccba917741996fb67f3339943c79.svg";